var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4,1.9C8.3,1.9,0.9,9.3,0.9,18.5C0.9,27.6,8.3,35,17.4,35c2.7,0,5.4-0.6,7.8-1.9c0.4-0.2,0.7-0.4,1-0.6 L37,41.8c1.1,1.2,2.8,1.6,4.4,1.2c1.3-0.2,2.4-1.2,2.6-2.5c0.4-1.6-0.3-3.3-1.7-4.3l-10.9-8.9c0.1-0.3,0.3-0.7,0.6-1 c1.3-2.4,2.1-5.1,2.1-7.8C34,9.3,26.6,1.9,17.4,1.9L17.4,1.9z M17.4,6.6c6.5,0,11.8,5.2,11.8,11.7c0,0,0,0.1,0,0.1 c0,3-1.1,5.9-3.1,8.1L26,26.7c-0.2,0.2-0.4,0.4-0.6,0.6c-2.2,2-5,3-8,3c-6.5,0-11.8-5.3-11.8-11.8S10.9,6.7,17.4,6.6L17.4,6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b35d0d83a5654c2835410da3e868f65e.svg";
export { ForwardRef as ReactComponent };